import { Component, Host, Prop, JSX, h, Event, EventEmitter } from '@stencil/core'
import { Category } from '@rdss/client'
import { appendQuicklinkTrackingInfo } from '~/utils/tracking'

interface QuickFilter {
    id: number
    label: string
    type?: string
    externalUrl?: string
    externalTarget?: string
    seoUrl?: string
}

@Component({
    tag: 'zr-quick-filter-container',
    styleUrl: 'zr-quick-filter-container.scss',
    scoped: false,
})

/**
 * ZooRoyal version of the quickfilter container component.
 */
export class ZrQuickFilterContainer {
    /**
     * A List of Quick filter links.
     */
    @Prop() categories: any[]

    /**
     * Event for tracking clicks on a quick-filter.
     */
    @Event() quickLinkClicked: EventEmitter<Category>

    /**
     * Event for tracking clicks on a tag.
     */
    @Event() quickFilterClicked: EventEmitter<string>

    /**
     * Event for emitting clicks on a tag.
     */
    private onQuickFilterClicked = (tagId:string) => this.quickFilterClicked.emit(tagId)

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return <Host>
            <div class='zr-quick-filter-container'>
                <div class='zr-quick-filter-container__list'>
                    {this.categories && this.categories.map((filter: QuickFilter) => {
                        const filterUrl = appendQuicklinkTrackingInfo(filter.externalUrl ?? filter.seoUrl,
                            filter.label)
                        return (
                            filterUrl
                                ? <a class='zr-quick-filter-container__tag'
                                    title={filter.label}
                                    target={filter.externalTarget ? filter.externalTarget : '_self'}
                                    href={filterUrl}>{filter.label}</a>
                                : <vx-tag
                                    label={filter.label}
                                    onClick={() => this.onQuickFilterClicked(filter.id.toString())}
                                ></vx-tag>
                        )
                    })}
                </div>
            </div>
        </Host>
    }
}
